module.exports = __webpack_public_path__ + "img/jk_icon_danweijigongchengjikenormal.73a7b6cd.png";